import { Box, Heading, Paragraph, TextButton } from '@zillow/constellation-10';
import Image from 'next/image';
import EmailSentIcon from '../../../assets/EmailSent.svg';

type EmailSentBodyProps = {
  email: string;
  onResetEmail: () => void;
};

const CONTENT = {
  HEADING: 'Your request for Zillow payments was sent',
  DESCRIPTION: "Once your landlord sets up payments, we'll follow up with you to get started.",
  YOUR_LANDLORD_LABEL: 'Your landlord',
  SEND_ANOTHER_REQUEST: "If you'd like to send another request for Zillow payments, ",
  SEND_ANOTHER_LINK: 'click here',
  CHANGE_MIND_TITLE: 'Change your mind?',
  CHANGE_MIND_DESCRIPTION: 'You can sign up for CreditClimb at any time from the "Your rental" page.',
} as const;

const EmailSentBody = ({ email, onResetEmail }: EmailSentBodyProps) => {
  return (
    <Box>
      <Box css={{ marginBottom: 'default' }}>
        <Image src={EmailSentIcon} alt="Email sent" width={120} height={120} />
      </Box>
      <Heading level={4} css={{ marginBottom: 'default' }} data-testid="email-sent-heading">
        {CONTENT.HEADING}
      </Heading>
      <Paragraph css={{ marginBottom: 'looser' }}>{CONTENT.DESCRIPTION}</Paragraph>
      <Paragraph textStyle="body" css={{ color: 'text.subtle', marginBottom: 'tightest' }}>
        {CONTENT.YOUR_LANDLORD_LABEL}
      </Paragraph>
      <Paragraph textStyle="body" css={{ marginBottom: 'looser' }}>
        {email}
      </Paragraph>
      <Paragraph css={{ marginBottom: 'looser' }}>
        {CONTENT.SEND_ANOTHER_REQUEST}
        <TextButton textStyle="body-bold" onClick={onResetEmail} data-testid="reset-form-button">
          {CONTENT.SEND_ANOTHER_LINK}
        </TextButton>
        .
      </Paragraph>
      <Paragraph css={{ marginBottom: 'looser' }}>
        <strong>{CONTENT.CHANGE_MIND_TITLE}</strong> {CONTENT.CHANGE_MIND_DESCRIPTION}
      </Paragraph>
    </Box>
  );
};

export default EmailSentBody;
